'use client';

import { useTranslations } from 'next-intl';
import { MyEquipmentButton } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';
import { useFormVisibleEvent } from 'hooks/analytics/use-form-visible-event';
import {
  ADD_EQUIPMENT_DRAWER_VIEW,
  STATUS_SUCCESS
} from 'constants/analyticsConstants';

export const AddMoreEquipmentButton = () => {
  const t = useTranslations();
  const { fireFormVisibleEvent } = useFormVisibleEvent();
  const isAddEquipmentDrawerChild = true;
  const { addEquipmentDrawer } = useMyEquipmentDrawer();
  const handleOpen = () => {
    fireFormVisibleEvent({
      formName: ADD_EQUIPMENT_DRAWER_VIEW,
      formStatus: STATUS_SUCCESS
    });
    addEquipmentDrawer.openDrawer(null, isAddEquipmentDrawerChild);
  };
  return (
    <MyEquipmentButton onClick={handleOpen}>
      {t('MEQ_ADD_EQUIP')}
    </MyEquipmentButton>
  );
};
